(() => {
    const queryString = require('query-string-es5');
    window.queryStringParameters = queryString.parse(window.location.search);
})();